<template>
  <div class="condition">
    <div class="flex-1">
      <el-select v-model="item.name" @change="conditionFirst" placeholder="请选择">
        <el-option
          v-for="obj in conditions"
          :key="obj.name"
          :label="obj.name"
          :value="obj.alias">
        </el-option>
      </el-select>      
    </div>
    <div class="flex-1">
      <el-select v-model="item.symbol" placeholder="请选择">
        <el-option
          v-for="(key, value) in select2"
          :key="key"
          :label="key"
          :value="value">
        </el-option>
      </el-select>     
    </div>
    <div class="flex-2" v-if="item.type !== 37">
      <template v-if="item.type === 4">
        <!-- 日期选择 -->
        <el-date-picker
          type="date"
          placeholder="选择日期"
          :editable="false"
          v-model="item.data"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </template>
      <!-- 数字类型 -->
      <template v-else-if="item.type === 2">
        <el-input-number v-model="item.data"></el-input-number>
      </template>
      <!-- 下拉选择 -->
      <template v-else-if="item.type === 3">
        <el-select clearable v-model="item.data" placeholder="请选择">
          <el-option
            v-for="obj in select3"
            :key="obj.key"
            :label="obj.value"
            :value="obj.key">
          </el-option>
        </el-select> 
      </template>
      <template v-else>
        <el-input placeholder="输入筛选内容" v-model="item.data"></el-input>
      </template>
    </div>
    <slot name="button"></slot>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object
    },
    conditions: {
      type: Array
    }
  },
  computed: {
    select2 () {
      if (typeof this.item.index === 'number') {
        return this.conditions[this.item.index].symbol
      } else {
        return {}
      }
    },
    select3 () {
      if (typeof this.item.index === 'number') {
        return this.conditions[this.item.index].initValue
      } else {
        return []
      }
    }
  },
  methods: {
    // 筛选条件选择
    conditionFirst (val) {
      this.item.symbol = ''
      this.item.data = ''
      this.conditions.forEach((obj, index) => {
        if (obj.alias === val) {
          this.item.index = index
          this.item.type = obj.type
          return
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .condition {
    display: flex;
    padding-bottom: 10px;
    .flex-1 {
      flex: 1;
      padding-right: 5px;
    }
    .flex-2 {
      flex: 1.5;
      padding-right: 5px;
    }
  }
</style>


// WEBPACK FOOTER //
// condition.vue?7d310bd4